import { Box, Modal, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useAPI from "../../../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../../../api/hooks/useColors";
import { Toast } from "../../../../../../../../components/Toast";
import SvgToIcon from "../../../../../../../../icons/SvgToIcon";
import { ReactComponent as SeverityGreenIcon } from "../../../../../../../../scenes/stack/environment/icons/severity_icons/severity-icons-success-24.svg";
import { ReactComponent as CloseIcon } from "../../../../../../../stack/environment/icons/close_icon.svg";
import { resetQueriesAfterAutoRemediation } from "../utils";

import TextButton from "../../../../../../../../components/buttons/TextButton";

export default function SuccessModal({
  controlID,
  showSuccessModal,
  handleClose,
}) {
  const queryClient = useQueryClient();
  const colors = useColors();
  const { reScanAfterAutoRemediation } = useAPI();

  const handleCloseSuccessModals = () => {
    if (!rollbackMutation.isPending) {
      handleClose();
    }
  };

  const rollbackMutation = useMutation({
    mutationFn: () => reScanAfterAutoRemediation(controlID),
    onSuccess: () => {
      resetQueriesAfterAutoRemediation(queryClient, controlID);
      Toast.success("Scan completed successfully");
      handleCloseSuccessModals();
    },
    onError: () => {
      Toast.error("Failed to rollback remediation");
      handleCloseSuccessModals();
    },
  });

  return (
    <Modal open={showSuccessModal} onClose={handleCloseSuccessModals}>
      <Box
        width="900px"
        position="absolute"
        borderRadius="10px"
        top="50%"
        left="50%"
        display="flex"
        justifyContent="space-between"
        padding="16px 16px 16px 8px"
        sx={{
          transform: "translate(-50%, -50%)",
          backgroundColor: colors.modal_bg,
          outline: "none",
          border: `1px solid ${colors.success_48percent}`,
        }}
      >
        <Box display="flex" justifyContent="center" padding="8px 16px">
          <Box
            width="24px"
            height="24px"
            borderRadius="8px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              backgroundColor: colors.success_8percent,
              boxShadow: "0px 0px 3px -1px " + colors.success_300_main,
            }}
          >
            <SvgToIcon IconLogo={SeverityGreenIcon} width="17px" />
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" flexGrow={1}>
          <Box display="flex" flexDirection="column" gap={"8px"} paddingY="8px">
            <Typography variant="subtitle1" color={colors.text_primary}>
              Remediation Applied Successfully
            </Typography>
            <Typography variant="body2" color={colors.text_primary}>
              The remediation was applied to the entities.
              <br />
              You can view details or undo it from the remediation history.
            </Typography>
          </Box>
          <Box
            display="flex"
            height="36px"
            alignItems="center"
            position="relative"
            left="-8px"
          >
            <TextButton
              onClick={() => rollbackMutation.mutate()}
              color="success"
              size="medium"
              loading={rollbackMutation.isPending}
            >
              Re-scan to confirm changes
            </TextButton>
          </Box>
        </Box>
        <Box>
          <Box
            height="18px"
            onClick={handleCloseSuccessModals}
            sx={{
              cursor: !rollbackMutation.isPending ? "pointer" : "auto",
            }}
          >
            <SvgToIcon
              IconLogo={CloseIcon}
              width="18px"
              style={{ color: colors.action_active }}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
